export function getTitle(issueCount: number, userFacingNoun: string): string {
    if (issueCount === 0) {
        return 'Ready for sending';
    }

    return `Prepare ${userFacingNoun} for sending`;
}

export function getSubtitle(issueCount: number, userFacingNoun: string): string {
    if (issueCount === 0) {
        return `This ${userFacingNoun} has all required items`;
    }

    if (issueCount === 1) {
        return `This ${userFacingNoun} is still missing a required item`;
    }

    return `This ${userFacingNoun} is still missing a few required items`;
}
